import React from "react";
import { useParams } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import { PageHeader } from "../../components/common";
import { FollowUpVisitsReport } from "../../components/FollowUpVisitsReport";

/**
 * Phase 196 — Reports › Follow-up Visits (Municipal Admin: every collector and supervisor).
 * Scheduled return visits entered during field visits, with status (Scheduled / Due today / Overdue / Done), the
 * collector's completion reason and remarks, the reschedule log and the Repeated Follow-up badge. Excel export.
 */
export default function FollowUpVisits() {
  const { code } = useParams();
  return (
    <div data-testid="admin-follow-up-visits-page">
      <PageHeader title="Follow-up Visits"
        subtitle="Every return visit scheduled by Tax Collectors and Supervisors during their field visits — filter by scheduled date, Zone, Ward, Supervisor or Collector. Overdue entries stay listed until they are marked Done; properties followed up 3 or more times without a payment carry the Repeated Follow-up badge.">
        <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground"><CalendarClock className="h-3.5 w-3.5" /> All collectors & supervisors</span>
      </PageHeader>
      <FollowUpVisitsReport code={code} role="admin" testId="admin-fu"
        propertyPath={(r) => `/${code}/admin/properties?focus=${r.property_id}`} />
    </div>
  );
}
